import store from './store';
import {OL_SSR_KEY, SSR_URL, STAGE, XPRT_SSR_KEY} from './constants';

export default {

  data() {
    return {
      store,
      state: store.state,
      baseUrls: []
    }
  },

  methods: {
    getBaseUrls() {

      if (this.state.baseUrls.length > 0) {
        return Promise.resolve();
      }

      return this.$http.get(`${SSR_URL}/?env=${STAGE}`)
        .then(res => {
          this.store.setBaseUrls(res.body);
          return Promise.resolve(res);
        }, err => {
          console.log(err);
        });
    }
  },

  computed: {
    olBaseURL() {
      if (this.state.baseUrls.length > 0) {
        return this.state.baseUrls.filter(base => base.key === OL_SSR_KEY)[0].url
      }
    },

    portalBaseURL() {
      if (this.state.baseUrls.length > 0) {
        return this.state.baseUrls.filter(base => base.key === XPRT_SSR_KEY)[0].url
      }
    }
  }
}
